import {
    DisplayAdFromRecentViewsExperiment,
    DisplayAdFromUserInterestsExperiment,
    DisplayAdFromUserLikesExperiment,
    DisplayAdFromUserOrdersExperiment,
    IncreaseAdsInHomepageExperiment,
} from '@eventbrite/discover-utils';
import { getExperiment } from '@eventbrite/statsig';

export function hasIncreasedAds() {
    const experiment = getExperiment(
        IncreaseAdsInHomepageExperiment.name,
        IncreaseAdsInHomepageExperiment.paramName,
        IncreaseAdsInHomepageExperiment.values.control,
    );

    return experiment === IncreaseAdsInHomepageExperiment.values.moreAds;
}

export function hasNewPersonalizedLikesBucket() {
    const experimentDisplayAdFromUserLikes = getExperiment(
        DisplayAdFromUserLikesExperiment.name,
        DisplayAdFromUserLikesExperiment.paramName,
        DisplayAdFromUserLikesExperiment.values.control,
    );

    return (
        experimentDisplayAdFromUserLikes ===
        DisplayAdFromUserLikesExperiment.values.recentLikes
    );
}

export function hasNewPersonalizedViewsBucket() {
    const experimentDisplayAdFromRecentViews = getExperiment(
        DisplayAdFromRecentViewsExperiment.name,
        DisplayAdFromRecentViewsExperiment.paramName,
        DisplayAdFromRecentViewsExperiment.values.control,
    );

    return (
        experimentDisplayAdFromRecentViews ===
        DisplayAdFromRecentViewsExperiment.values.recentViews
    );
}

export function hasNewPersonalizedInterestsBucket() {
    const experimentDisplayAdFromInterests = getExperiment(
        DisplayAdFromUserInterestsExperiment.name,
        DisplayAdFromUserInterestsExperiment.paramName,
        DisplayAdFromUserInterestsExperiment.values.control,
    );

    return (
        experimentDisplayAdFromInterests ===
        DisplayAdFromUserInterestsExperiment.values.userInterests
    );
}

export function hasNewPersonalizedOrdersBucket() {
    const experimentDisplayAdFromOrders = getExperiment(
        DisplayAdFromUserOrdersExperiment.name,
        DisplayAdFromUserOrdersExperiment.paramName,
        DisplayAdFromUserOrdersExperiment.values.control,
    );

    return (
        experimentDisplayAdFromOrders ===
        DisplayAdFromUserOrdersExperiment.values.userOrders
    );
}

export const INCREASED_REGULAR_TAB_AD_SLOTS = [1, 6, 9, 10];
